import { useCallback, useEffect, useState } from "react";
import { Plus, Pencil } from "lucide-react";
import { api, eur } from "@/lib/api";
import { ProductDialog, EMPTY_PRODUCT as EMPTY } from "@/components/QuickDialogs";
import { useAuth, canWrite } from "@/context/AuthContext";
import { PageHeader, Empty } from "@/components/Common";
import { ConfirmDelete } from "@/components/ConfirmDelete";
import { PrintButton } from "@/components/PrintButton";
import { LabelsDialog } from "@/components/LabelsDialog";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";


export default function Products() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const [edit, setEdit] = useState(null);
  const load = useCallback(() => api.get("/products").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);


  return (
    <div>
      <PageHeader title="Articoli e servizi" subtitle="Listino da richiamare nelle righe fattura">
        <PrintButton testid="print-products-button" path="/stampe/articoli.pdf" />
        <LabelsDialog items={items || []} />
        {canWrite(user) && <Button data-testid="add-product-button" className="bg-sky-600 hover:bg-sky-700" onClick={() => setEdit({ ...EMPTY })}><Plus className="mr-2 h-4 w-4" />Nuovo articolo</Button>}
      </PageHeader>
      {items && items.length === 0 ? <Empty text="Nessun articolo a listino" /> : (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
          <Table data-testid="products-table">
            <TableHeader><TableRow className="bg-slate-50">
              <TableHead>Codice</TableHead><TableHead>Codice a barre</TableHead><TableHead>Descrizione</TableHead><TableHead>U.M.</TableHead><TableHead className="text-right">Prezzo</TableHead><TableHead>IVA</TableHead><TableHead />
            </TableRow></TableHeader>
            <TableBody>
              {(items || []).map((p) => (
                <TableRow key={p.id} data-testid={`product-row-${p.id}`}>
                  <TableCell className="font-mono text-xs">{p.codice}</TableCell>
                  <TableCell className="font-mono text-xs" data-testid={`product-barcode-${p.id}`}>{p.barcode}</TableCell>
                  <TableCell className="font-medium">{p.descrizione}</TableCell>
                  <TableCell className="text-sm">{p.unita}</TableCell>
                  <TableCell className="text-right font-mono">{eur(p.prezzo)}</TableCell>
                  <TableCell className="font-mono text-sm">{p.aliquota ? `${p.aliquota}%` : p.natura}</TableCell>
                  <TableCell className="whitespace-nowrap text-right">
                    {canWrite(user) && <>
                      <Button variant="ghost" size="icon" data-testid={`edit-product-${p.id}`} onClick={() => setEdit({ ...p })}><Pencil className="h-4 w-4" /></Button>
                      <ConfirmDelete testid={`delete-product-${p.id}`} onConfirm={async () => { await api.delete(`/products/${p.id}`); load(); }} />
                    </>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
      <ProductDialog value={edit} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); load(); }} />
    </div>
  );
}
